<ag-link-to-negotiation #linkToNegotiationModal
[company]="company"
(linked)="linkedListener($event)"></ag-link-to-negotiation>
<ag-link-to-contract #linkToContractModal
[company]="company"
(linked)="linkedListener($event)"></ag-link-to-contract>